import React from 'react';
import PropTypes from 'prop-types';
import { SubscriptionShape } from '../../shapes';
import ApplePayIcon from './apple_pay_icon';

export default class MobilePaymentRequestButton extends React.Component {
  static propTypes = {
    subscription: SubscriptionShape,
    onPopupMobilePaymentOptions: PropTypes.func,
    onSubscribe: PropTypes.func
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.subscription.get('mobilePaymentToken') && this.props.subscription.get('mobilePaymentToken')) {
      this.props.onSubscribe(this.props.subscription.get('mobilePaymentToken'));
    }
  }

  render() {
    if (this.props.subscription.get('mobilePaymentMethod') === 'apple-pay') {
      return (
        <div className='center'>
          <button className='apple-pay-button' onClick={ this.onPopupMobilePaymentOptions.bind(this) } >
            <ApplePayIcon />
          </button>
          <p className='center give-me-15-up-and-down'>or</p>
        </div>
      )
    } else if (this.props.subscription.get('mobilePaymentMethod') === 'google-pay') {
      return (
        <div className='center'>
          <button className='google-pay-button' onClick={ this.onPopupMobilePaymentOptions.bind(this) } >
            <div className="google-play-logo"></div>
          </button>
          <p className='center give-me-15-up-and-down'>or</p>
        </div>
      )
    } else return null;
  }

  onPopupMobilePaymentOptions(event) {
    event.preventDefault();
    this.props.onPopupMobilePaymentOptions();
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/mobile_payment_request_button.jsx